export const THEMES = {
    black:   { accent: "#1a1a1a", dark: "#0a0a0a", name: "Dark Mode", hl: "#aaaaaa", darkMode: true },
    crimson: { accent: "#A51C30", dark: "#7a1423", name: "Harvard Crimson" },
    yale:    { accent: "#00356B", dark: "#002454", name: "Yale Blue" },
};

export const ADMIN_PW = process.env.REACT_APP_ADMIN_PW;
export const PAGES = ["home", "about", "projects", "gallery", "resume", "contact"];
export const GOOGLE_FONT = `@import url('https://fonts.googleapis.com/css2?family=Special+Elite&display=swap');`;
